import { Col } from '../grid';
export default Col;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/col/index.js
// module id = 318
// module chunks = 3